import script from "./LoansView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoansView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__